import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  margin-left: 15px;\n'], ['\n  margin-left: 15px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n'], ['\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin-left: auto;\n'], ['\n  margin-left: auto;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  margin: 0px 10px;\n'], ['\n  margin: 0px 10px;\n']);

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { styles, translations, utils } from 'gipsy-misc';
import { Icon, UserPicture, Tooltip, LargeButton } from '../..';
import InlineFields from '../fields/InlineFields';
import { FooterContainer } from '../../Panel';

var Footer = function (_PureComponent) {
  _inherits(Footer, _PureComponent);

  function Footer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Footer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Footer.__proto__ || Object.getPrototypeOf(Footer)).call.apply(_ref, [this].concat(args))), _this), _this.makeTooltipText = function () {
      var _this$props = _this.props,
          creator = _this$props.creator,
          creationTime = _this$props.creationTime;

      var tooltipText = '';
      if (creator && creator.displayName && creationTime) {
        var name = utils.user.getDisplayName(creator);
        var date = utils.datetime.humanizeDateTime(creationTime);
        if (date === 'Today') {
          tooltipText = 'Created ' + date + ' by ' + name;
        } else {
          tooltipText = 'Created by ' + name + ' on ' + date;
        }
      }
      return tooltipText;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Footer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          mode = _props.mode,
          disabled = _props.disabled,
          create = _props.create,
          togglePrompt = _props.togglePrompt,
          creator = _props.creator;


      var tooltipText = this.makeTooltipText();

      return React.createElement(
        FooterContainer,
        { className: 'panel-footer' },
        React.createElement(
          BottomBar,
          { className: 'bottom-bar' },
          React.createElement(InlineFields, { fields: this.props.fields, activateField: this.props.activateField }),
          mode === 'edit' && React.createElement(
            DeleteButton,
            null,
            React.createElement(DeleteIcon, { size: 18, icon: 'Trash', onClick: function onClick(e) {
                return togglePrompt(e);
              } })
          ),
          mode === 'edit' && creator && React.createElement(
            StyledUserPicture,
            { size: 28, src: creator && creator.picture },
            React.createElement(Tooltip, { text: tooltipText, position: 'top left', vs: 40, hs: 28 })
          )
        ),
        !!create && React.createElement(
          LargeButton,
          { rightIconName: 'Plus', disabled: disabled, onClick: create },
          translations.taskPanel.createTask
        )
      );
    }
  }]);

  return Footer;
}(PureComponent);

Footer.propTypes = {
  mode: PropTypes.string.isRequired,
  fields: PropTypes.array,
  activateField: PropTypes.func.isRequired,
  create: PropTypes.func,
  togglePrompt: PropTypes.func,
  disabled: PropTypes.bool,
  creator: PropTypes.object,
  creationTime: PropTypes.string
};


export default Footer;

var StyledUserPicture = styled(UserPicture)(_templateObject);

var BottomBar = styled.div(_templateObject2);

var DeleteButton = styled.div(_templateObject3);

var DeleteIcon = styled(Icon)(_templateObject4);
//# sourceMappingURL=Footer.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/components/Footer.js
// module id = 1118
// module chunks = 0